import React, { useState, useEffect } from 'react';
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams } from 'react-router-dom';
import ImageSlider from '../../components/common/ImageSlider';
import axios from 'axios';
import Loader from '../../components/common/Loader';
import EditArticleModal from '../../components/modals/EditArticleModal';

const ArticlesDetails = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [articleById, setArticleById] = useState();
    const [articeLoader, setArticeLoader] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    useEffect(() => {
        getArticle();
    }, [])

    const getArticle = () => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/articles/get-articles-by-id/${params?.id}`,
            headers: {},
            data: ''
        };

        setArticeLoader(true);
        axios.request(config)
            .then((response) => {
                setArticeLoader(false);
                setArticleById(response.data);
            })
            .catch((error) => {
                setArticeLoader(false);
                console.log(error);
            });
    };

    const deleteArticleById = () => {
        let config = {
            method: 'delete',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/articles/delete-articles/${params?.id}`,
            headers: {},
            data: ''
        };

        setIsLoading(true);
        axios.request(config)
            .then((response) => {
                setIsLoading(false);
                navigate(-1);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const handleEdit = () => {
        setIsEditModalOpen(true);
    };

    const handleCloseEditModal = () => {
        setIsEditModalOpen(false);
    };

    const reloadArticleDetails = () => {
        getArticle(); // Reload article details after editing
    };

    return (
        <React.Fragment>
            <div className="mx-4 mt-4 px-4 py-5 bg-gradient-to-r from-[#2f9bd6] to-[#7cc9f3] rounded-md">
                <div className='w-full flex justify-start items-center'>
                    <div onClick={() => navigate(-1)} className='cursor-pointer'>
                        <FaArrowLeft size={24} color='#ffffff' />
                    </div>
                    <h1 className="ml-2 text-xl font-semibold text-[#ffffff] tracking-wider">
                        Article Details
                    </h1>
                </div>
            </div>
            {
                articeLoader
                    ?
                    <div className='mt-4 mx-4 rounded-md flex tracking-wider font-semibold justify-center items-center border border-slate-400 p-4'>
                        <Loader /> <span className='ml-2'>Please Wait..</span>
                    </div>
                    :
                    articleById && (
                        <>
                            <h1 className="text-2xl text-center font-semibold my-4">
                                {articleById.title}
                            </h1>

                            <div className="mx-auto">
                                <ImageSlider images={articleById.images} />
                            </div>

                            <div className='mx-4 tracking-wider block md:flex justify-start md:justify-between items-center mt-4'>
                                <div className='text-gray-500 text-sm font-semibold'>
                                    By {articleById.author}
                                </div>

                                <div className='text-gray-500 text-sm font-semibold'>
                                    On {articleById.createdAt.split('T')[0]}
                                </div>
                            </div>

                            <p className="text-gray-800 m-4 tracking-wide text-lg text-justify">
                                {articleById.description}
                            </p>

                            <div className="flex justify-center items-center flex-wrap space-x-2 my-4 md:mt-0">
                                <button
                                    onClick={handleEdit} // Open edit modal on click
                                    className="w-16 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={deleteArticleById}
                                    className="w-16 py-2 flex justify-center bg-red-500 text-white rounded-md hover:bg-red-600 transition"
                                >
                                    {
                                        isLoading
                                            ?
                                            <Loader />
                                            :
                                            'Delete'
                                    }
                                </button>
                            </div>
                            <EditArticleModal
                                open={isEditModalOpen}
                                handleClose={handleCloseEditModal}
                                articleData={articleById} // Pass article data to EditArticleModal
                                reloadArticleDetails={reloadArticleDetails} // Callback function to reload article details after editing
                            />
                        </>
                    )
            }
        </React.Fragment>
    )
}

export default ArticlesDetails;
